import React, { useState } from 'react';
import { getAuditoriaErros } from '../api';
import { ModalPrint } from './ModalPrint';

/**
 * "Ver print" na linha do popup de Processos (13/10, pedido do dono: "é bom
 * retornar o botão de ver o print também para eu conseguir fazer tudo na
 * própria tela").
 *
 * A linha do popup não carrega a key do print — só a auditoria carrega. Então o
 * botão busca SOB DEMANDA as ocorrências daquela empresa naquele bot, na mesma
 * janela da tela, e abre o print mais recente que existir. Sem print registrado
 * ele diz isso, em vez de abrir uma imagem quebrada.
 */
interface BotaoVerPrintProps {
  bot: string;
  codiEmp: string;
  de?: string;
  ate?: string;
}

type Estado = 'parado' | 'buscando' | 'sem_print' | 'falhou';

export const BotaoVerPrint: React.FC<BotaoVerPrintProps> = ({ bot, codiEmp, de, ate }) => {
  const [estado, setEstado] = useState<Estado>('parado');
  const [printKey, setPrintKey] = useState<string | null>(null);

  const abrir = async () => {
    if (estado === 'buscando') return;
    setEstado('buscando');
    try {
      const resposta = await getAuditoriaErros({ bot, codi_emp: codiEmp, de, ate, limit: 50 });
      const comPrint = resposta.itens.find(item => item.tem_print && item.print_key);
      if (comPrint?.print_key) {
        setPrintKey(comPrint.print_key);
        setEstado('parado');
      } else {
        setEstado('sem_print');
      }
    } catch {
      setEstado('falhou');
    }
  };

  let rotulo = '🖼 ver print';
  if (estado === 'buscando') rotulo = 'buscando print…';
  else if (estado === 'sem_print') rotulo = 'sem print registrado';
  else if (estado === 'falhou') rotulo = 'não consegui buscar o print — tentar de novo';

  return (
    <>
      <button
        type="button"
        onClick={abrir}
        disabled={estado === 'sem_print'}
        aria-label={`Ver print do erro: ${codiEmp}`}
        style={{
          alignSelf: 'flex-start',
          padding: 0,
          border: 'none',
          background: 'none',
          font: 'inherit',
          fontSize: '11px',
          fontWeight: 600,
          color: estado === 'sem_print' ? 'oklch(0.62 0.01 165)' : 'oklch(0.4 0.08 165)',
          cursor: estado === 'sem_print' ? 'default' : 'pointer',
          textAlign: 'left',
        }}
      >
        {rotulo}
      </button>
      <ModalPrint printKey={printKey} onClose={() => setPrintKey(null)} />
    </>
  );
};
